var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.47386 4.21373C6.75787 4.49871 6.75787 4.96075 6.47386 5.24573L4.48306 7.24324H13.6364C16.0463 7.24324 18 9.20351 18 11.6216C18 14.0397 16.0463 16 13.6364 16H10C9.59834 16 9.27273 15.6733 9.27273 15.2703C9.27273 14.8673 9.59834 14.5405 10 14.5405H13.6364C15.243 14.5405 16.5455 13.2337 16.5455 11.6216C16.5455 10.0095 15.243 8.7027 13.6364 8.7027H4.48306L6.47386 10.7002C6.75787 10.9852 6.75787 11.4472 6.47386 11.7322C6.18984 12.0172 5.72935 12.0172 5.44534 11.7322L2.21301 8.48897C1.929 8.20399 1.929 7.74195 2.21301 7.45698L5.44534 4.21373C5.72935 3.92876 6.18984 3.92876 6.47386 4.21373Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackward);
export default __webpack_public_path__ + "static/media/backward.076be514afad12bf5460098fe495868b.svg";
export { ForwardRef as ReactComponent };